__webpack_require__.p = "/gateway/api/graphql/graphiql/";